import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/Api/ApiServices";

export const GetOneAI_NT_ApI_ApplicantInformation = createAsyncThunk(
  "GetOneAI_NT_ApI_ApplicantInformation/GetOneAI_NT_ApI_ApplicantInformation",
  async (parameters, { rejectWithValue }) => {
    try {
      const apiClient = getApiClient();
      const response = await apiClient.post(
        "api/AI_NT_ApI_ApplicantInformation/GetOneAI_NT_ApI_ApplicantInformation",
        parameters
      );

      const data = response.data.result; // Assuming response has a "data" field
      console.log(data, "Qasem");
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const UpdateAI_NT_ApI_ApplicantInformation = createAsyncThunk(
  "UpdateAI_NT_ApI_ApplicantInformation/UpdateAI_NT_ApI_ApplicantInformation",
  async (parameters, { rejectWithValue }) => {
    try {
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/AI_NT_ApI_ApplicantInformation/UpdateAI_NT_ApI_ApplicantInformation",
        parameters
      );

      const data = response.data; // Assuming response has a "data" field
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const GetAllCountryOfResidence = createAsyncThunk(
  "GetAllCountryOfResidence/GetAllCountryOfResidence",
  async (parameters, { rejectWithValue }) => {
    try {
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/AI_ST_ApI_CountryOfResidence/GetAllAI_ST_ApI_CountryOfResidence",
        parameters
      );

      const data = response.data.result; // Assuming response has a "data" field
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const GetAllNationality = createAsyncThunk(
  "GetAllNationality/GetAllNationality",
  async (parameters, { rejectWithValue }) => {
    try {
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/AI_ST_ApI_Nationality/GetAllAI_ST_ApI_Nationality",
        parameters
      );

      const data = response.data.result; // Assuming response has a "data" field
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const ValidateApplicationInformationPage = createAsyncThunk(
  "ValidateApplicationInformationPage/ValidateApplicationInformationPage",
  async (applicationInformationId, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/AI_NT_ApI_ApplicantInformation/ValidateApplicationInformationPage",
        { applicationInformationId: applicationInformationId }
      );

      const data = response.data.result; // Assuming response has a "data" field
      if (response.data.success === true) {
        const arrayValidate = response.data.result.map((ele, ind) => {
          return ele.code;
        });
        return arrayValidate; // Return the extracted data
      }
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const ApplicantInformation = createSlice({
  name: "ApplicantInformation",
  initialState: {
    //------------- GetOneApplicant ---------------------
    ApplicantInformation: {},
    loadingApplicantInformation: false,
    errorApplicantInformation: null,
    //------------- Update Applicant ---------------------
    UpdateApplicantInformation: {},
    loadingUpdateApplicantInformation: false,
    errorUpdateApplicantInformation: null,

    //--------------CountryOfResidence-----------------------
    CountryOfResidence: [],
    loadingCountryOfResidence: false,
    errorCountryOfResidence: null,
    //--------------Nationality-----------------------
    Nationality: [],
    loadingNationality: false,
    errorNationality: null,
    //************************************* */
    ValidateApplicantInformationList: [],
    loadingValidateApplicantInformationList: false,
    errorApplicantInformationList: null,
  },
  reducers: {
    setApplicantInformation: (state, action) => {
      state.ApplicantInformation = action.payload;
    },
    
  },
  extraReducers: (builder) => {
    builder
      .addCase(
        GetOneAI_NT_ApI_ApplicantInformation.pending,
        (state, action) => {
          console.log(action.payload, "action.payload");

          state.loadingApplicantInformation = true;
          state.ApplicantInformation = action.payload;
          state.errorApplicantInformation = null;
        }
      )
      .addCase(
        GetOneAI_NT_ApI_ApplicantInformation.fulfilled,
        (state, action) => {
          state.loadingApplicantInformation = false;
          state.ApplicantInformation = action.payload;
        }
      )
      .addCase(
        GetOneAI_NT_ApI_ApplicantInformation.rejected,
        (state, action) => {
          state.loadingApplicantInformation = false;
          state.ApplicantInformation = action.payload;
        }
      );
    //------------- Update Applicant ---------------------
    builder
      .addCase(
        UpdateAI_NT_ApI_ApplicantInformation.pending,
        (state, action) => {
          state.loadingUpdateApplicantInformation = true;
          state.UpdateApplicantInformation = action.payload;
          state.errorUpdateApplicantInformation = null;
        }
      )
      .addCase(
        UpdateAI_NT_ApI_ApplicantInformation.fulfilled,
        (state, action) => {
          state.loadingUpdateApplicantInformation = false;
          state.UpdateApplicantInformation = action.payload;
        }
      )
      .addCase(
        UpdateAI_NT_ApI_ApplicantInformation.rejected,
        (state, action) => {
          state.loadingUpdateApplicantInformation = false;
          state.errorUpdateApplicantInformation = action.payload;
        }
      );
    //------------- CountryOf Residence ---------------------
    builder
      .addCase(GetAllCountryOfResidence.pending, (state, action) => {
        state.loadingCountryOfResidence = true;
        state.CountryOfResidence = action.payload;
        state.errorCountryOfResidence = null;
      })
      .addCase(GetAllCountryOfResidence.fulfilled, (state, action) => {
        state.loadingCountryOfResidence = false;
        state.CountryOfResidence = action.payload;
      })
      .addCase(GetAllCountryOfResidence.rejected, (state, action) => {
        state.loadingCountryOfResidence = false;
        state.errorCountryOfResidence = action.payload;
      });
    //------------- Nationality ---------------------
    builder
      .addCase(GetAllNationality.pending, (state, action) => {
        state.loadingNationality = true;
        state.Nationality = action.payload;
        state.errorNationality = null;
      })
      .addCase(GetAllNationality.fulfilled, (state, action) => {
        state.loadingNationality = false;
        state.Nationality = action.payload;
      })
      .addCase(GetAllNationality.rejected, (state, action) => {
        state.loadingNationality = false;
        state.errorNationality = action.payload;
      })
      ////////////////////////////////////////////////
      .addCase(ValidateApplicationInformationPage.pending, (state, action) => {
        state.loadingValidateMainResearcherPageList = true;
        state.ValidateApplicantInformationList = action.payload;
        state.errorApplicantInformationList = null;
      })
      .addCase(
        ValidateApplicationInformationPage.fulfilled,
        (state, action) => {
          state.loadingValidateApplicantInformationList = false;
          state.ValidateApplicantInformationList = action.payload; // Assuming payload has the desired data
        }
      )
      .addCase(ValidateApplicationInformationPage.rejected, (state, action) => {
        state.loadingValidateApplicantInformationList = false;
        state.ValidateApplicantInformationList = action.payload;
      });
  },
});

export const { setApplicantInformation } =
  ApplicantInformation.actions;
export default ApplicantInformation.reducer;
